
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { ArrayHelper } from "../../../dev/utils/ArrayHelper";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { BonusCounters } from "../../independent/countup/BonusCounters";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { GameData } from "../../server/data/BaseModel";
import { RoadRage } from '../../RoadRage';
import { Translator } from '../../../dev/setting/Translator';
import { TranslationTexts } from '../../config/translate/TranslationTexts';

class featureStates extends StateHandler {
    public static START: string = "start";
    public static DONE: string = "done";
}

export class RespinPresentation extends Presentation {

    private gameData: GameData;
    private state: featureStates = new featureStates();

    private scatterReelLanded:boolean[] = []

    setGamedData(data: GameData): void {
        this.gameData = data;
        this.scatterReelLanded = ArrayHelper.initArrayWithValues(RoadRageEngineManager.AllReels.length, (i) => data.Reel.scatterPositions[i] >= 0) ;
    }

    preStart(): void {
        this.state.set(featureStates.START);
     }

    checkForActivation(data: GameData) {
        return data.nextIsRespin;
    }

    createPresentation(enableSkip: Function) {
        enableSkip(false);

        if(RoadRage.counter.timeRemaining){
            this.timeline.to(this,{duration:RoadRage.counter.timeRemaining});
            return;
        }
        
        switch (this.state.value) {
            case featureStates.START:
                SlotGame.keypadPlugin.hide(0.25);
                RoadRage.backgroundElements.speedUpCloud();
                this.timeline.add(BonusCounters.instance.playRespin());
                this.state.set(featureStates.DONE);
                break;
            default:
                // RoadRageEngineManager.RAll(r => { if(this.scatterReelLanded[r.reelID]) r.attention(true); })
                this.PresentationState.setInactive();
        }

        if(this.timeline.totalDuration() > 0)
            this.timeline.to(this, { duration: 0.1 })
    }
 
    done(): void {

        SlotGame.keypadPlugin.show(0.25);

    }
}